import { ProjectApi } from '@/project/ProjectApi';
import type { Project } from '@/project/model';

export const ProjectSelectApi = {
  queryProjects(searchKey: string, dateRange: Date): Promise<Project[]> {
    const queryParam = ProjectApi.getQueryProjectParam(searchKey, dateRange);
    return ProjectApi.queryProjects(queryParam);
  },
};

export const projectSelectApi = ProjectSelectApi;
